import { useTranslation } from "react-i18next";
import { Form, Grid, GridColumn } from "semantic-ui-react";

import { createFormHelper } from "lib/Form";

import type { DealerDMSEvaConfig } from "models";
import type { AddEditDealerFormPayload } from "modules/DMSv3/Settings/components/AddEditDealerModal";

export type EvaConfig = Pick<DealerDMSEvaConfig, "dms_lease_customer_ids" | "dms_lease_customer_category_ids">;

const FormHelper = createFormHelper<AddEditDealerFormPayload>();

export const EvaConfigSection = () => {
  const { t } = useTranslation();

  return (
    <Grid columns="equal">
      <GridColumn>
        <Form.Field>
          <label>{t("v8_dms_lease_customer_id", "DMS Lease Customer ID")} </label>
          <FormHelper.Field.Input name="eva_config.dms_lease_customer_ids" inputProps={{ fluid: true }} />
        </Form.Field>
      </GridColumn>

      <GridColumn>
        <Form.Field>
          <label>{t("v8_dms_lease_customer_category_id", "DMS Lease Customer Category ID")} </label>
          <FormHelper.Field.Input name="eva_config.dms_lease_customer_category_ids" inputProps={{ fluid: true }} />
        </Form.Field>
      </GridColumn>
    </Grid>
  );
};
